import React from "react";
import { createRoot } from "react-dom/client";
import { ViewerProvider } from "./members/Viewer";
import VideoSite from "./videos/VideoSite";
import "@fontsource/dm-sans/latin-400.css";
import "@fontsource/dm-sans/latin-500.css";
import "@fontsource/dm-sans/latin-700.css";
import "@fontsource/manrope/latin-400.css";
import "@fontsource/manrope/latin-700.css";
import "@fontsource/manrope/latin-800.css";
import "./portal/portal.css";
import "./portal/apple-install.css";
import "./locale.css";
import "./members/device-account.css";

// 独立播放入口：域名根地址直接显示视频库。
createRoot(document.getElementById("root")!).render(
  <React.StrictMode><ViewerProvider><VideoSite /></ViewerProvider></React.StrictMode>,
);
